import { Injectable, Inject } from '@angular/core';
import { AgAppConfigService } from '@ag/vc.ag-core/settings';
import { WINDOW, AgWindow } from '@ag/vc.ag-core/tokens';

@Injectable({
    providedIn: 'root'
})
export class DecommissionRedirectGuardService {
    constructor(@Inject(WINDOW) private readonly window: AgWindow) { }

    canActivateChild(): boolean {
        const hostname = this.window.location.hostname.toLowerCase();
        // web.json(.localhost) configures both domain settings as "localhost" purely for ParamGuard's local dist-channel matching
        if (hostname === 'localhost') {
            return true;
        }

        const isDigitalHost = this.getHosts('digitaldomainurl').includes(hostname);
        const isBrokerHost = this.getHosts('brokerdomainurl').includes(hostname);

        if (!isDigitalHost && !isBrokerHost) {
            return true;
        }

        if (isDigitalHost && this.isAllowedDigitalSignInPath(this.window.location.pathname)) {
            return true;
        }

        if (!this.hasBlockedDistributionChannel(this.window.location.search)) {
            return true;
        }

        this.window.location.replace(this.getRedirectUrl(this.window.location.search));
        return false;
    }

    private getHosts(settingName: 'digitaldomainurl' | 'brokerdomainurl'): string[] {
        return (AgAppConfigService.get<string>(settingName) ?? '')
            .split(',')
            .map(hostname => hostname.trim().toLowerCase())
            .filter(Boolean);
    }

    private isAllowedDigitalSignInPath(pathname: string): boolean {
        return pathname.replace(/\/$/, '') === '/easyinvest/authentication/signIn';
    }

    // Analyst update: distcha=0 redirects to AG public investment pages; distcha=1 redirects to Yongo on any configured host is decommissioned; everything else stays reachable
    private hasBlockedDistributionChannel(search: string): boolean {
        const distcha = new URLSearchParams(search).get('distcha');
        return distcha === '0' || distcha === '1';
    }

    /*private getYongoUrl(search: string): string {
        const language = new URLSearchParams(search).get('lang')?.toLowerCase();
        return language === 'fr' || language === 'nl'
            ? `https://yongo.be/${language}`
            : 'https://yongo.be/';
    }*/

    private getRedirectUrl(search: string): string {
        const params = new URLSearchParams(search);
        const distcha = params.get('distcha');
        const language = params.get('lang')?.toLowerCase();

        if (distcha === '0') {
            return language === 'fr'
                ? 'https://ag.be/particuliers/fr/epargner-investir/faire-fructifier-mon-capital'
                : 'https://ag.be/particulieren/nl/sparen-beleggen/ik-laat-mijn-geld-renderen';
        }

        // distcha=1
        return language === 'fr' || language === 'nl'
            ? `https://yongo.be/${language}`
            : 'https://yongo.be';
    }
}
